module.exports = __webpack_public_path__ + "img/innovating.eecfcc7.png";